import {useRef, useEffect} from 'react';

import { withTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import imagesLoaded from 'imagesloaded';

import config from 'config/config.json';

import styles from './TommyMain.module.scss';

import SkewGallery from 'components/SkewGallery';
import img1 from 'assets/images/Drum_img_01.png';
import img2 from 'assets/images/Drum_img_02.png';
import img3 from 'assets/images/Drum_img_03.png';
import img4 from 'assets/images/Drum_img_04.png';

import FlagSection from 'components/FlagSection';
import ParallaxSection from 'components/ParallaxSection';
import ProductCarousel from 'components/ProductCarousel';
import ScrollingText from 'components/ScrollingText';

import NFTModule from 'components/NFT';

const {showNFTModule, showDrop2Preview} = config;

const TommyMain = ({children, t}) => {
	const location = useLocation();
	const nftRef = useRef(null)
	const shopRef = useRef(null)

	useEffect(() => {
    imagesLoaded(
    	document.body, { background: true },
    	() => {
				if (location.pathname.toLowerCase().includes('nft')) {
					setTimeout(() => {
						nftRef && nftRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
					}, 500);
				}
    	}
  	)
	}, [location]);

	const handleSkewGalleryButton = () => {
		window.TTB?.onAnalyticsEvent("click_cta", "scroll_shopthecollection", "engagement");
		return shopRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
	}

	return <div className={styles.Tommy_wrap}>
		<SkewGallery>
			<img src={img1} alt=""/>
			<img src={img2} alt=""/>
			<img src={img3} alt=""/>
			<img src={img4} alt=""/>
		</SkewGallery>
		<section className={styles.Flagsection}>
			<FlagSection />
		</section>
		{/* Starts Bottom Slide Section */}
		<section className={styles.section2}>
			<div className={styles.shoprefOverlay}></div>
  		<ParallaxSection handleSkewGalleryButton={handleSkewGalleryButton}/>
  		<span className={styles.shopRef} ref={shopRef} />
			<ProductCarousel/>
		</section>
		{/* Ends Bottom Slide Section */}

		{/* Start scrolling text with Video*/}
		<div className={styles.Slidetext}>
			<ScrollingText/>
		</div>
		{/* End scrolling text with Video*/}

		{/* Starts widget Section */}
		{showNFTModule && (
			<section ref={nftRef} className={showDrop2Preview ? styles.nftmodule : ''}>
				<NFTModule showText showInfoTab />
			</section>
		)}
		{/* Ends widget Section */}

	</div>

}

export default withTranslation()(TommyMain);